/**
 * TikTok Pixel event tracking
 * Fires AddToCart on cart-message:added and InitiateCheckout on checkout button clicks.
 * Guards on window.ttq — no-ops silently if OneTrust blocked the base pixel.
 */
(function () {
  function track(event, params) {
    if (!window.ttq) return;
    window.ttq.track(event, params || {});
  }

  var currency = (window.themeSettings && window.themeSettings.currency) || null;

  // AddToCart — fired by product form and bundle on every successful ATC
  window.addEventListener('cart-message:added', function (event) {
    var detail = (event && event.detail) || {};
    var params = {};

    if (currency) params.currency = currency;

    if (detail.variant_id) {
      params.contents = [{
        content_id: String(detail.variant_id),
        content_type: 'product',
        quantity: detail.quantity || 1,
        price: detail.price ? detail.price / 100 : undefined,
      }];
      params.content_type = 'product';
      if (detail.price) params.value = detail.price / 100;
    }

    track('AddToCart', params);
  });

  // InitiateCheckout — covers:
  //   <a href="/checkout"> (mini-cart, cart notification)
  //   <button name="checkout"> (inline-cart form)
  document.addEventListener('click', function (event) {
    var el = event.target.closest('[href="/checkout"], [name="checkout"]');
    if (!el) return;

    track('InitiateCheckout', currency ? { currency: currency } : {});
  });
})();
